// extracted by mini-css-extract-plugin
export default {"field":"CustomField_field__XJHUr","error":"CustomField_error__OtkC5","leftPosition":"CustomField_leftPosition__6CAqs"};